import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss']
})
export class ImageSliderComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ImageSliderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit(): void {
    if (this.data.images.length) {
      // Map to links first
      const links = this.data.images.map(item => item.link);

      // Sort: images first, videos next
      this.data.images = links.sort((a, b) => {
        const aIsImage = this.isImage(a);
        const bIsImage = this.isImage(b);

        if (aIsImage && !bIsImage) return -1;  // a is image, b is video => a first
        if (!aIsImage && bIsImage) return 1;   // a is video, b is image => b first
        return 0; // same type, keep order
      });
    }
  }

  isVideo(link: string): boolean {
    const videoExtensions = ['mp4', 'avi', 'mov', 'wmv'];
    return videoExtensions.some(ext => link.toLowerCase().endsWith(ext));
  }

  isImage(link: string): boolean {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
    return imageExtensions.some(ext => link.toLowerCase().endsWith(ext));
  }

}
